module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-MorningCanoe-Web-640.13380f52.jpg";